import React from 'react';

import { OpportunitiesListPage } from '../../shared/opportunities';
import { ORGANIZATION_OPPORTUNITIES_LIST_QUERY_KEY } from './queryKeys';

const OpportunityList: React.FC = () => {
  return (
    <OpportunitiesListPage
      title="Opportunities"
      queryKeyBase={ORGANIZATION_OPPORTUNITIES_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationOpportunities"
      showOrganization={false}
      linkContext="organization"
      queueCategory="HealthcareEntityOpportunityQueueNames"
    />
  );
};

export default OpportunityList;
